module.exports = __webpack_public_path__ + "img/customer.61d6133a.png";